import { string } from 'yup';

const marketplaceItemDescription = string().required('Please enter a description').trim('Description must not include leading or trailing spaces');

export { marketplaceItemDescription };
